import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      marginTop: 60,
      padding: '24px 0',
      borderTop: '1px solid var(--border-secondary)',
      textAlign: 'center',
      fontSize: 12,
      color: 'var(--text-muted)',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      fontFamily: 'Orbitron, sans-serif'
    }}>
      © {new Date().getFullYear()} AMSG Protocol — Secured by BNB Chain
    </footer>
  );
};

export default Footer;
